/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ClusterStateEnum } from './ClusterStateEnum';
import {
    ClusterStateEnumFromJSON,
    ClusterStateEnumFromJSONTyped,
    ClusterStateEnumToJSON,
} from './ClusterStateEnum';

/**
 * 
 * @export
 * @interface ClusterStateSchema
 */
export interface ClusterStateSchema {
    /**
     * 
     * @type {number}
     * @memberof ClusterStateSchema
     */
    id: number;
    /**
     * 
     * @type {Date}
     * @memberof ClusterStateSchema
     */
    created: Date;
    /**
     * 
     * @type {Date}
     * @memberof ClusterStateSchema
     */
    updated: Date;
    /**
     * 
     * @type {ClusterStateEnum}
     * @memberof ClusterStateSchema
     */
    state: ClusterStateEnum;
    /**
     * 
     * @type {string}
     * @memberof ClusterStateSchema
     */
    reason: string;
}

/**
 * Check if a given object implements the ClusterStateSchema interface.
 */
export function instanceOfClusterStateSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "created" in value;
    isInstance = isInstance && "updated" in value;
    isInstance = isInstance && "state" in value;
    isInstance = isInstance && "reason" in value;

    return isInstance;
}

export function ClusterStateSchemaFromJSON(json: any): ClusterStateSchema {
    return ClusterStateSchemaFromJSONTyped(json, false);
}

export function ClusterStateSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClusterStateSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'created': (new Date(json['created'])),
        'updated': (new Date(json['updated'])),
        'state': ClusterStateEnumFromJSON(json['state']),
        'reason': json['reason'],
    };
}

export function ClusterStateSchemaToJSON(value?: ClusterStateSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'created': (value.created.toISOString()),
        'updated': (value.updated.toISOString()),
        'state': ClusterStateEnumToJSON(value.state),
        'reason': value.reason,
    };
}

